import DateFormat from "components/DateFormat";
import DefaultCurrency from "components/DefaultCurrency";
import useAlert from "hooks/useAlert";
import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Container,
  Form,
  InputGroup,
  Row,
  Table,
} from "react-bootstrap";
import { Pencil, Trash, X } from "react-bootstrap-icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Details from "../details/Details";

const DraftOrders = () => {
  // states
  const [docs, setDocs] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);

  // hooks
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const alert = useAlert();

  // functions
  const search = (val) => {
    if (!searchValue && !val) return;

    setSearchValue(val);
    if (searchTimer) clearTimeout(searchTimer);
    setSearchTimer(
      setTimeout(() => {
        setDocs([]);
        setCurrentPage(1);
        refetch({
          search: val,
          page: 1,
        });
      }, 400)
    );
  };

  const remove = (doc) => {
    alert
      .fire({
        title: `Remove Draft-SO-${doc.dId}`,
        text: "Do you want to remove this drafted document?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Cancel",
        denyButtonText: "Yes, delete it!",
      })
      .then((confirmed) => {
        if (confirmed.isDenied) {
          const newSet = docs.filter((x) => x.dId !== doc.dId);
          setDocs(newSet);
          localStorage.setItem("sales", JSON.stringify(newSet));
          toast.success("Document is deleted.");
          setSelectedOrder(null);
        }
      });
  };

  const loadDocs = () => {
    const docs = JSON.parse(localStorage.getItem("sales") || "[]");
    docs.sort((a, b) => (a.dId > b.dId ? -1 : 1));
    setDocs(docs);
    if (searchParams.get("open")) {
      setSelectedOrder(docs.find((x) => x.dId == searchParams.get("open")));
      setSearchParams({});
    }
  };

  // effects
  useEffect(() => {
    loadDocs();
  }, []);

  return (
    <React.Fragment>
      {selectedOrder && (
        <Details
          order={selectedOrder}
          setOrder={setSelectedOrder}
          edit={(x) => navigate(`/dashboard/sales/orders/form${x.id ? `/${x.id}` : ''}?d-id=${x.dId}`)}
          remove={remove}
          draft
        />
      )}
      <Container fluid className="mt-2">
        <Row>
          <InputGroup className="mb-3">
            <Form.Control
              value={searchValue}
              onChange={(e) => search(e.target.value)}
              placeholder="Search..."
              className="w-auto"
            />
            <X
              className="w-auto h-100 border rounded-right"
              onClick={() => search("")}
              size={20}
            />
          </InputGroup>
        </Row>
        {docs.length !==
          JSON.parse(localStorage.getItem("sales") || "[]").length && (
            <Row className="my-1">
              <Badge bg="warning" className="w-auto">
                Some orders are submitted. Please refresh the data.
              </Badge>
            </Row>
          )}
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Doc Number</th>
              <th>Customer</th>
              <th>Total Sales Value</th>
              <th>Doc Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="position-relative">
            {docs.length !==
              JSON.parse(localStorage.getItem("sales") || "[]").length && (
                <div className="position-absolute top-0 h-100 w-100 bg-black bg-opacity-25 d-flex justify-content-center align-items-center">
                  <Button
                    variant="primary"
                    className="bg-primary"
                    onClick={loadDocs}
                  >
                    Refresh
                  </Button>
                </div>
              )}
            {docs.map((x, index) => (
              <tr key={x.dId}>
                <td>{index + 1}</td>
                <td>
                  <span
                    className="link-primary cursor-pointer"
                    onClick={() => setSelectedOrder(x)}
                  >
                    {x.docNumber || "-"}
                  </span>
                </td>
                <td>{x.customer?.name}</td>
                <td>
                  <DefaultCurrency
                    value={x.details.reduce(
                      (pre, cur) => pre + cur.quantity * cur.salesPrice,
                      0
                    )}
                  />
                </td>
                <td>
                  <DateFormat value={x.docDate} />
                </td>
                <td className="text-center">
                  <Pencil
                    size={20}
                    color="darkorange"
                    className="mx-2 cursor-pointer"
                    onClick={() => navigate(`/dashboard/sales/orders/form${x.id ? `/${x.id}` : ''}?d-id=${x.dId}`)}
                  />
                  <Trash
                    onClick={() => remove(x)}
                    size={20}
                    color="darkred"
                    className="mx-2 cursor-pointer"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </React.Fragment>
  );
};

export default DraftOrders;
